import React from 'react';
import { DscrCalculator } from './pages/DscrCalculator';
interface AppProps {
  showScenarioHistory?: boolean;
}
export function App({
  showScenarioHistory = true
}: AppProps) {
  return <DscrCalculator showScenarioHistory={showScenarioHistory} data-id="element-0" data-mp="3k9b31xkoffzm" />;
}